import axios from 'axios';
import BaseService from './baseService';

interface PasswordResetRequest {
  email: string;
}

interface PasswordResetResponse {
  message: string;
  success: boolean;
}

class PasswordResetService extends BaseService {
  async requestReset(data: PasswordResetRequest): Promise<PasswordResetResponse> {
    try {
      const response = await axios.post(
        `${this.getApiUrl()}/auth/esqueci-senha`,
        data
      );
      return response.data;
    } catch (error: any) {
      throw error;
    }
  }

  async confirmReset(token: string, newPassword: string): Promise<PasswordResetResponse> {
    try {
      const response = await axios.post(
        `${this.getApiUrl()}/auth/mudar-senha`,
        {
          token,
          new_password: newPassword,
          confirm_password: newPassword
        }
      );
      return response.data;
    } catch (error: any) {
      throw error;
    }
  }

  async validateToken(token: string): Promise<boolean> {
    try {
      // Como não existe uma rota específica para validação, 
      // vamos tentar fazer uma requisição para mudar senha com uma senha temporária
      // Se retornar erro específico de senha inválida, significa que o token é válido
      const response = await axios.post(
        `${this.getApiUrl()}/auth/mudar-senha`,
        {
          token,
          new_password: 'temp_password_123',
          confirm_password: 'temp_password_123'
        }
      );
      return true; // Se chegou aqui, o token é válido
    } catch (error: any) {
      // Se o erro for relacionado à validação de senha, o token é válido
      if (error.response?.status === 400 && 
          (error.response?.data?.new_password || error.response?.data?.confirm_password)) {
        return true;
      }
      // Se o erro for 404 ou relacionado ao token, o token é inválido
      return false;
    }
  }
}

export const passwordResetService = new PasswordResetService();
export default PasswordResetService;
